import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GET_FLIGHTS_RESULT_STORE_NAME, GetFlightsResultState } from './get-flights-result.state';

/** Select GetFlightsResult State */
export const selectGetFlightsResultState = createFeatureSelector<GetFlightsResultState>(GET_FLIGHTS_RESULT_STORE_NAME);

/** Select GetFlightsResult isPending status */
export const selectGetFlightsResultIsPendingStatus = createSelector(
  selectGetFlightsResultState,
  (state) => !!state.isPending
);

/** Select GetFlightsResult isFailure status */
export const selectGetFlightsResultIsFailureStatus = createSelector(
  selectGetFlightsResultState,
  (state) => !!state.isFailure
);
